import axios from '../../library/modules/axios'
export function additionalInfo(data) {
  return axios.service({
    url: `/apis/v1/appointment-order/customer/additional-info`,
    method: 'post',
    data
  })
}
export function upload(data) {
  return axios.service({
    url: `/apis/v1/data/customer/oss/file/upload`,
    method: 'post',
    data
  })
}
export function getitionalInfo(params) {
  return axios.service({
    url: `/apis/v1/appointment-order/customer/additional-info`,
    method: 'get',
    params
  })
}
